export default "__VITE_ASSET__CrqEZglZ__"